//  React TS Helper Functions
import pxToRem from '../functions/pxToRem'

// types
type Types = any

const icon: Types = {
  defaultProps: {
    baseClassName: 'material-icons-round',
    fontSize: 'inherit',
  },

  styleOverrides: {
    fontSizeInherit: {
      fontSize: 'inherit',
    },

    fontSizeSmall: {
      fontSize: `${pxToRem(20)}`,
    },

    fontSizeLarge: {
      fontSize: `${pxToRem(36)}`,
    },
  },
}

export default icon
